import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useBreakpoint = () => {
  const { breakpoints } = useTheme();

  return {
    isDesktop: useMediaQuery(breakpoints.up('lg')),
    isTablet: useMediaQuery(breakpoints.between('md', 'lg')),
    isMobile: useMediaQuery(breakpoints.down('md')),
  };
};
